/* eslint-disable prettier/prettier */
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "abortcontroller-polyfill/dist/polyfill-patch-fetch";
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import React, { useEffect, useCallback } from "react";
import ReactDOM from "react-dom";
import AccountInfo from "./Profile/AccountInfo";
import Catalog from "./MithraMain/Catalog/Catalog";
import Settings from "./settings"
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import Watermarks from "./Profile/Details/Watermarks";
import moment from "moment";
import { BecomePartner } from "./BecomePartner/BecomePartner";
import { VideosPopup } from "./Videos/VideosPopup";
import { VideosSwiper } from "./Videos/VideosSwiper";
import { VideosPopupProvider } from "./Videos/VideosPopupContext";
import { AllVideosView } from "./Videos/AllVideosView.js"
import StartTariff from "../ReactComponents/Common/BuyTariffs/StartTariffBuy";
import BasicTariff from "../ReactComponents/Common/BuyTariffs/BasicTariffBuy";
import BuisinessTariff from "../ReactComponents/Common/BuyTariffs/BuisinessTariffBuy";
import SaleOrigPaintingsMain from "../ReactComponents/SaleOrigPaintings/SaleOrigPaintingsMain";
import NewsList from "./Ui/News/NewsList";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
const queryClient = new QueryClient();

import Boutique from "../ReactComponents/MithraRealty/Boutique/Catalog";
const boutique = document.getElementById('boutiqueRealty');
import ContactForm from "./Shared/ContactForm";

import Header from "./MithraMain/Header";
import Footer from "./MithraMain/Footer";

import ApplicationPopup from "./Popups/ApplicationPopup";

if (boutique) {
    console.log(boutique.getAttribute("data-category-id"));
    var date1 = moment(boutique.getAttribute("data-start-date"), 'YYYY-MM-DDTHH:mm:ss');
    var date2 = moment(boutique.getAttribute("data-end-date"), 'YYYY-MM-DDTHH:mm:ss');
    console.log(date1, date2);
    ReactDOM.render(

        <React.Suspense fallback={<div className="loading show"></div>}>
            <Boutique CategoryId={Number(boutique.getAttribute("data-category-id"))}
                CurrentPage={Number(boutique.getAttribute("data-current-page"))}
                CountLotsOnPage={Number(boutique.getAttribute("data-count-lots-on-page"))}
                AuctionType={Number(boutique.getAttribute("data-auction-type"))}
                SalesType={Number(boutique.getAttribute("data-sales-type"))}
                TimeSearch={Number(boutique.getAttribute("data-time-search"))}
                StartDate={date1.isValid() ? date1.format('YYYY-MM-DDTHH:mm:ss') : NaN}
                EndDate={date2.isValid() ? date1.format('YYYY-MM-DDTHH:mm:ss') : NaN}
                StartPrice={Number(boutique.getAttribute("data-start-price"))}
                EndPrice={Number(boutique.getAttribute("data-end-price"))}
            />
        </React.Suspense>,
        boutique,
    );
}


// метод инициализирующий класс AccountInfo
const LoadAccountInfo = (result) => {
    console.log('загрузим даные об аккаунте');
    const accountInfo = document.getElementById("accountInfo");

    if (accountInfo) {
        console.log("accountInfo найден!!!");
        AccountInfo.Thumbprint = accountInfo.getAttribute('data-thumbprint');
        AccountInfo.Id = Number(accountInfo.getAttribute('data-id'));
        AccountInfo.Fio = accountInfo.getAttribute('data-fio');
        AccountInfo.IsAdminRole = accountInfo.getAttribute('data-isAdminRole');
        AccountInfo.CurrentUserCanSign = Boolean(accountInfo.getAttribute('data-currentUserCanSign'));
        AccountInfo.init(LoadAll);
        console.log('AccountInfo: ', AccountInfo);
    } else {
        console.log("accountInfo не найден");
        LoadAll();
    }
}

// вызовет инициализацию настроек, которые нам могут понадобиться в любом другом компоненте
Settings.Init(LoadAccountInfo);

// метод загружающий все другие комопненты. !!! Внимание он должен быть вызван после получения данных настроект и информации об аккаунте!
const LoadAll = (result) => {

    const but = document.querySelector(".but")

    if (but) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <QueryClientProvider client={queryClient}>
                    <ApplicationPopup>
                        <a className="bottom-item-3 bottom-item"
                            style={{display: "block"}}
                        >
                            <h4><span>Не нашли</span> Лот?</h4>
                            <p>Опишите свой запрос, и мы <br /> обязательно найдем идеальное <br /> предложение для вас</p>
                        </a>
                    </ApplicationPopup>
                </QueryClientProvider>
            </React.Suspense>,
            but,
        );
    }

    const contactFormRender = document.querySelector(".contactFormRender");
    if (contactFormRender) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <QueryClientProvider client={queryClient}>
                    <ContactForm />
                </QueryClientProvider>
            </React.Suspense>,
            contactFormRender,
        );
    }

    const newsList = document.querySelector(".newsList");
    if (newsList) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <QueryClientProvider client={queryClient}>
                    <NewsList
                        Count={newsList.getAttribute("data-count")}
                    />
                </QueryClientProvider>
            </React.Suspense>,
            newsList,
        );
    }

    const headerW = document.getElementsByClassName("headerMenu");
    if (headerW) {
        for (let i of headerW) {
            ReactDOM.render(
                <React.Suspense fallback={<div className="loading show"></div>}>
                    <Header
                        mode={i.getAttribute("data-mode")}
                    />
                </React.Suspense>,
                i,
            );
        }
    }

    const footerWrapper = document.querySelectorAll(".footer");
    if (footerWrapper.length) {
        footerWrapper.forEach(i => (
            ReactDOM.render(
                <React.Suspense fallback={<div className="loading show"></div>}>
                    <QueryClientProvider client={queryClient}>
                        <Footer />
                    </QueryClientProvider>
                </React.Suspense>,
                i,
            )
        ))
    }

    const SaleOrigPaintingsMainWrapper = document.getElementById('saleOrigPaintMain');
    if (SaleOrigPaintingsMainWrapper) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show"></div>}>
                <SaleOrigPaintingsMain />
            </React.Suspense>,
            SaleOrigPaintingsMainWrapper,
        );
    }

    const contactForm = document.getElementsByClassName("feedback-form_wrapper2");
    if (contactForm) {
        for (let i of contactForm) {
            ReactDOM.render(
                <React.Suspense fallback={<div className="loading show"></div>}>
                    <QueryClientProvider client={queryClient}>
                        <ContactForm />
                    </QueryClientProvider>
                </React.Suspense>,
                i,
            );
        }
    }

    const BecomePartnerContainer = document.getElementById("BecomePartner");
    if (BecomePartnerContainer) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show" />}>
                <BecomePartner></BecomePartner>
            </React.Suspense>,
            BecomePartnerContainer,
        );
    }

    const VideosSwiperContainer = document.getElementById("VideosSwiperContainer");
    if (VideosSwiperContainer) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show" />}>
                <VideosPopupProvider>
                    <VideosPopup></VideosPopup>
                    <VideosSwiper></VideosSwiper>
                </VideosPopupProvider>
            </React.Suspense>,
            VideosSwiperContainer,
        );
    }

    const header = document.getElementsByClassName("headerMenu");
    if (header) {
        for (let i of header) {
            ReactDOM.render(
                <React.Suspense fallback={<div className="loading show"></div>}>
                    <Header />
                </React.Suspense>,
                i,
            );
        }
    }

    const allVideosViewContainer = document.getElementById("allVideosViewContainer");
    if (allVideosViewContainer) {
        ReactDOM.render(
            <React.Suspense fallback={<div className="loading show" />}>
                <VideosPopupProvider>
                    <VideosPopup></VideosPopup>
                    <AllVideosView></AllVideosView>
                </VideosPopupProvider>
            </React.Suspense>,
            allVideosViewContainer,
        );
    }

    //const startTarifPopup = document.getElementById("startTarifPopup");
    //if (startTarifPopup) {
    //    ReactDOM.render(
    //        <React.Suspense fallback={<div className="loading show"></div>}>
    //            <StartTariff

    //            />
    //        </React.Suspense>,
    //        startTarifPopup
    //    );
    //}

    //const basicTarifPopup = document.getElementById("basicTarifPopup");
    //if (basicTarifPopup) {
    //    ReactDOM.render(
    //        <React.Suspense fallback={<div className="loading show"></div>}>
    //            <BasicTariff

    //            />
    //        </React.Suspense>,
    //        basicTarifPopup
    //    );
    //}

    //const buisinessTarifPopup = document.getElementById("buisinessTarifPopup");
    //if (buisinessTarifPopup) {
    //    ReactDOM.render(
    //        <React.Suspense fallback={<div className="loading show"></div>}>
    //            <BuisinessTariff

    //            />
    //        </React.Suspense>,
    //        buisinessTarifPopup
    //    );
    //}


    const catalogRef = document.getElementById('catalogLots');
    if (catalogRef) {
        console.log(catalogRef.getAttribute("data-category-id"));
        var date1 = moment(catalogRef.getAttribute("data-start-date"), 'YYYY-MM-DDTHH:mm:ss');
        var date2 = moment(catalogRef.getAttribute("data-end-date"), 'YYYY-MM-DDTHH:mm:ss');
        console.log(date1, date2);
        ReactDOM.render(

            <React.Suspense fallback={<div className="loading show"></div>}>
                <Catalog CategoryId={Number(catalogRef.getAttribute("data-category-id"))}
                    CurrentPage={Number(catalogRef.getAttribute("data-current-page"))}
                    CountLotsOnPage={Number(catalogRef.getAttribute("data-count-lots-on-page"))}
                    AuctionType={Number(catalogRef.getAttribute("data-auction-type"))}
                    SalesType={Number(catalogRef.getAttribute("data-sales-type"))}
                    TimeSearch={Number(catalogRef.getAttribute("data-time-search"))}
                    StartDate={date1.isValid() ? date1.format('YYYY-MM-DDTHH:mm:ss') : NaN}
                    EndDate={date2.isValid() ? date1.format('YYYY-MM-DDTHH:mm:ss') : NaN}
                    StartPrice={Number(catalogRef.getAttribute("data-start-price"))}
                    EndPrice={Number(catalogRef.getAttribute("data-end-price"))}
                    TextSearch={catalogRef.getAttribute("data-text-search")}
                    mitraTheme={catalogRef.getAttribute("data-theme")}
                />
            </React.Suspense>,
            catalogRef,
        );
    }
}


console.log('MainSite Branch');
